var scope_0 = require('/workspaces/nucleoingeneria/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6d80eec27b422228462d248e8aeb627d.js').default;
var scope_1 = require('/workspaces/nucleoingeneria/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/75d71a05a4b950ab3946670e03fc9fd0.js').default;
var scope_2 = require('/workspaces/nucleoingeneria/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    